import React from "react"
import { Button } from "react-bootstrap"

import InfoPopover from "../../../../shared_components/widgets/InfoPopover"
import ExternalParentSearch from "./ExternalParentSearch"

export default function ParentalComponent({
  intl,
  field,
  updateField,
  selectedOpts = [],
  getMatchingInstance = () => {},
  headers = [],
  showButton = true,
  disableAddRowButton = false,
  canRemoveRow = false,
  removeRow,
  infoPopoverMsg,
}) {
  const { ColDisplay, ...addRowButtonLabel } = headers[0] // First header in table and button label are currently always the same
  return (
    <div className={"row"}>
      <div className={"col-12"}>
        {showButton && (
          <>
            <Button
              variant={"outline-primary"}
              size={"sm"}
              style={{ marginBottom: "3px" }}
              disabled={disableAddRowButton}
              onClick={(e) => {
                e.preventDefault()
                updateField(field, null, null, null, "row")
              }}
            >
              <i className={"fa fa-plus"} />
              &nbsp;&nbsp;
              {intl.formatMessage(addRowButtonLabel)}
            </Button>
            {infoPopoverMsg && (
              <>
                &nbsp;&nbsp;
                <InfoPopover desc={infoPopoverMsg} placement={"bottom"} />
              </>
            )}
            {["external_samples", "external_runs"].includes(field) && selectedOpts.length > 0 && (
              <ExternalParentSearch externalParent={field} intl={intl} />
            )}
          </>
        )}
        {selectedOpts.length > 0 && (
          <table
            className={"table table-sm tbl_lanzatable"}
            style={{ width: "100%", margin: "auto", marginBottom: "15px" }}
          >
            <thead>
              <tr>
                {headers.map((h, idx) => (
                  <th key={`${field}header${idx}`} className={"text-center"}>
                    {intl.formatMessage({ id: h.id, defaultMessage: h.default })}
                  </th>
                ))}
                {canRemoveRow && <th>&nbsp;</th>}
              </tr>
            </thead>
            <tbody>
              {selectedOpts.map((entry, idx) => {
                const instance = getMatchingInstance(entry)
                return (
                  <tr
                    key={`${field}entry${idx}`}
                    style={{
                      backgroundColor: entry.complete
                        ? "var(--lanzalake-white)"
                        : "var(--lanzalake-red-light)",
                    }}
                  >
                    {headers.map((h, hIDX) => {
                      return (
                        <td
                          key={`${field}entry${idx}_${hIDX}`}
                          className={"text-center"}
                          style={{ verticalAlign: "middle" }}
                        >
                          {h["ColDisplay"](instance, entry, idx)}
                        </td>
                      )
                    })}
                    {canRemoveRow && (
                      <td className={"text-center"}>
                        <Button
                          variant={"outline-primary"}
                          size={"sm"}
                          disabled={!canRemoveRow}
                          onClick={(e) => {
                            e.preventDefault()
                            removeRow && removeRow()
                            updateField(field, null, null, idx, "removeRow")
                          }}
                        >
                          <i className="fa fa-times text-danger" />
                        </Button>
                      </td>
                    )}
                  </tr>
                )
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}
